import { Pipe, PipeTransform } from '@angular/core';
import { IQuotationCost, IQuotationRetail, IQuotationVatConfiguration } from "libraries/service/resources/quotation-quotations/IQuotationsQuotation";
import { EVatDisplayMode } from "libraries/service/vat/vat.interface";

@Pipe({
  name: 'retailAccordingToVat'
})
export class RetailAccordingToVatPipe implements PipeTransform {

  public transform(vatConfiguration: IQuotationVatConfiguration, retail: IQuotationRetail, retailIncludingVat: IQuotationCost): IQuotationCost {
    if (!retail || !vatConfiguration) {
      return null;
    }

    return vatConfiguration.vatDisplayMode === EVatDisplayMode.includingVAT
        ? retailIncludingVat
        : retail;
  }

}
